export interface IEmailTemplate {
  id: number;
  css: string;
  html: string;
  params: string[];
  subject: string;
  text: string;
  type: string;
}
